import ModerationHistoryTable from './ModerationHistoryTable';
export default ModerationHistoryTable;
